module.exports = __webpack_public_path__ + "static/media/crystal-narrow.94b0b663.png";